<template>
  <div :class="isMobile ? 'mobile-main-header' : 'main-header'">
    <v-card flat class="text-left" style="background: transparent;">
      <v-card-text>
        <div style="display: flex; flex-direction: row; justify-content: start; align-items: center;">
          <v-btn
            v-if="backable"
            class="mr-5"
            x-large
            icon
            @click="onClickBack"
          >
            <v-icon x-large>
              mdi-arrow-left
            </v-icon>
          </v-btn>
          <div class="title">
            {{ title }}
            <slot name="append-title" />
          </div>
        </div>
      </v-card-text>
    </v-card>

    <v-card flat class="text-left" style="background: transparent;">
      <v-card-text>
        <div style="display: flex; flex-direction: row; justify-content: start; align-items: center;">
          <slot name="btn-wrapper" />
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "MainHeader",
  props: {
    backable: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: undefined,
    },
    isMobile: {
      type: Boolean,
      default: false,
    }
  },
  methods: {
    onClickBack() {
      this.$router.go(-1);
    },
  }
}
</script>

<style scoped>
.mobile-main-header {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: start;
  margin-left: -15px;
}

.main-header {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: start;
}

.title {
  font-size: 1.5rem;
  font-weight: bold;
}
</style>